import { Resource } from "../models/resource.model";

export abstract class WorklistResourcesProvider {
    abstract getAvailableResources(worklistId): Promise<Resource[]>;
    abstract isAllowedToChangeResources(worklist): Promise<boolean>;
    abstract saveUpdateResource(worklistId, selectedResource): Promise<any>;
}